"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Breadcrumb = _interopRequireDefault(require("./Breadcrumb"));
var _default = exports["default"] = _Breadcrumb["default"];